import { createSelector } from '@ngrx/store';
import { UserState } from './user.reducer';

export interface UserStoreState {
  user: UserState;
}

export const selectUserState = (state: UserStoreState) => state;

export const selectUserFormLoading = createSelector(
  selectUserState,
  ({ user }) => user.loadingUserForm
);

export const selectGetUsersLoading = createSelector(
  selectUserState,
  ({ user }) => user.loadingGetUsers
);

export const selectUserRolesReady = createSelector(
  selectUserState,
  ({ user }) => user.loadingSetUserRoles
);
